import axios from 'axios';
import { pickBy } from 'lodash';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

let cancelTokenList;
let cancelTokenConfig;
export const getList = (payload) => {
  if (typeof cancelTokenList !== typeof undefined) {
    cancelTokenList.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenList = axios.CancelToken.source();
  return axiosInstance.get('/child-panels/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenList.token,
  });
};

export const getConfig = (payload) => {
  if (typeof cancelTokenConfig !== typeof undefined) {
    cancelTokenConfig.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenConfig = axios.CancelToken.source();
  return axiosInstance.get('/child-panels/configuration', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenConfig.token,
  });
};

export const cancelChildPanel = (id) => axiosInstance.post(`/child-panels/cancel/${id}`, pickDevParams);
